<template>
  <div class="support-view container">
    <BLoading :active.sync="isLoading" />
    <div v-if="!isLoading">
      <div v-if="currentProperty" class="support-view--address-wrapper" test-id="address-card">
        <LsAddressCard :property="currentProperty" />
      </div>
      <SupportWithSearch
        :all-actions-by-category="allActionsByCategory"
        :filtered-actions="localActions"
        :all-actions="allActions"
        :show-categories="!hasSearchQuery"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import {
  SUPPORT__GET_SEARCHABLE_ACTIONS,
  SUPPORT__SEARCHABLE_ACTIONS_FILTERED_BY_SEARCH_QUERY,
  PROPERTY_MANAGER__SHOW_SINGLE_PROPERTY,
  PROPERTY_MANAGER__CURRENT_PROPERTY_ID,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
} from '@/store/types';
import { SupportWithSearch } from './components';
import { LsAddressCard } from '@/components/common';
import { getSearchableActionsByCategory } from '@/store/modules/support/support.helpers';
import { ACTIONS_BY_CATEGORY, SUPPORTED_ACTIONS } from '@/store/modules/support/support.constants';

export default {
  name: 'SupportView',
  components: {
    SupportWithSearch,
    LsAddressCard,
  },
  data() {
    return {
      localActions: [],
      allActionsByCategory: {},
      hasSearchQuery: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapState(['support', 'properties']),
    ...mapGetters([
      SUPPORT__SEARCHABLE_ACTIONS_FILTERED_BY_SEARCH_QUERY,
      PROPERTY_MANAGER__SHOW_SINGLE_PROPERTY,
      PROPERTY_MANAGER__CURRENT_PROPERTY_ID,
    ]),
    allActions() {
      return this.support.searchableActions;
    },
    currentProperty() {
      if (
        this[PROPERTY_MANAGER__SHOW_SINGLE_PROPERTY] &&
        this[PROPERTY_MANAGER__CURRENT_PROPERTY_ID]
      ) {
        return this.properties.propertiesById[this[[PROPERTY_MANAGER__CURRENT_PROPERTY_ID]]];
      }

      return null;
    },
  },
  watch: {
    '$store.state.support.searchQuery': 'setLocalActions',
  },
  async created() {
    this.isLoading = true;

    await this[SUPPORT__GET_SEARCHABLE_ACTIONS]();
    if (this[PROPERTY_MANAGER__SHOW_SINGLE_PROPERTY]) {
      await this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]({
        forceRefresh: this[PROPERTY_MANAGER__CURRENT_PROPERTY_ID] ? false : true,
      });
    }

    this.localActions = this[SUPPORT__SEARCHABLE_ACTIONS_FILTERED_BY_SEARCH_QUERY];
    this.allActionsByCategory = getSearchableActionsByCategory(
      this.allActions,
      SUPPORTED_ACTIONS,
      ACTIONS_BY_CATEGORY
    );

    this.isLoading = false;
  },
  methods: {
    ...mapActions([SUPPORT__GET_SEARCHABLE_ACTIONS, PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]),
    setLocalActions() {
      this.localActions = this[SUPPORT__SEARCHABLE_ACTIONS_FILTERED_BY_SEARCH_QUERY];
      this.hasSearchQuery = !!this.support.searchQuery;
    },
  },
};
</script>
<style lang="scss">
.support-view {
  .support-view--address-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin: 55px 0 40px;
  }
}
</style>
